import { useTranslation, Trans } from "react-i18next";

import g1 from '../../img/partner/g1.png';
import g2 from '../../img/partner/g2.png';
import g3 from '../../img/partner/g3.png';

import Button from '../Button'

function HowMuch () {

    const { t } = useTranslation();

    return(
        <div className="overflow-hidden relative z-50">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[100px] xl:mt-[140px] flex flex-col">
                <p className="text-[24px] xl:text-[48px] text-[#000000] manrope leading-[1.2] font-[500] mx-auto">{t('partner.10')}</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-y-[45px] mt-[40px] xl:mt-[70px]">
                    <div className="flex flex-col items-center md:border-r border-[#13131380]">
                        <img src={g1} alt="Graphic 1" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" />
                        <p className="max-w-[190px] text-[#000000B2] roboto text-[14px] xl:text-[16px] mt-[20px] xl:mt-[30px] text-center">{t('partner.11')}</p>
                    </div>
                    <div className="flex flex-col items-center md:border-r border-[#13131380]">
                        <img src={g2} alt="Graphic 2" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" />
                        <p className="max-w-[190px] text-[#000000B2] roboto text-[14px] xl:text-[16px] mt-[20px] xl:mt-[30px] text-center">{t('partner.12')}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <img src={g3} alt="Graphic 3" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]" />
                        <p className="max-w-[190px] text-[#000000B2] roboto text-[14px] xl:text-[16px] mt-[20px] xl:mt-[30px] text-center">{t('partner.13')}</p>
                    </div>
                </div>
            </div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[100px] xl:mt-[140px] flex flex-col xl:flex-row gap-[20px] xl:h-[604px]">
                <div className="bg-[#131313] flex flex-col items-start flex-grow rounded-[20px] px-[20px] xl:px-[40px] xl:w-[600px]">
                    <p className="text-[20px] xl:text-[32px] manrope pt-[40px] xl:pt-[60px] text-white font-[500] leading-[1.2]">{t('partner.14')}</p>
                    <p className="text-[#FFFFFFB2] text-[12px] xl:text-[14px] roboto mt-[20px] font-[300]">{t('partner.15')}</p>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[35px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.16')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.17')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.18')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.19')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.20')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.21')}</p>
                    </div>
                    <Button main={true} className={"xl:absolute pb-[40px] xl:pb-0 mt-[40px] bottom-[40px]"}/>
                </div> 
                <div className="bg-[#131313] flex flex-col items-start flex-grow rounded-[20px] px-[20px] xl:px-[40px] xl:w-[600px]">
                    <p className="text-[20px] xl:text-[32px] manrope pt-[40px] xl:pt-[60px] text-white font-[500] leading-[1.2]">{t('partner.22')}</p>
                    <p className="text-[#FFFFFFB2] text-[12px] xl:text-[14px] roboto mt-[20px] font-[300]">{t('partner.23')}</p>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[35px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.24')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.25')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.26')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.27')}</p>
                    </div>
                    <div className="flex gap-[12px] xl:gap-[22px] mt-[8px]">
                        <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                            <circle cx="3" cy="3" r="3" fill="white"/>
                        </svg>
                        <p className="text-[#FFFFFFB2] roboto text-[12px] xl:text-[14px]">{t('partner.28')}</p>
                    </div>
                    <Button main={true} className={"xl:absolute pb-[40px] xl:pb-0 mt-[40px] bottom-[40px]"}/>
                </div> 
            </div>      
        </div>
    );
}

export default HowMuch;